import { render, staticRenderFns } from "./DoctorProfile.vue?vue&type=template&id=83f2a7f6&scoped=true"
import script from "./DoctorProfile.vue?vue&type=script&lang=js"
export * from "./DoctorProfile.vue?vue&type=script&lang=js"
import style0 from "./DoctorProfile.vue?vue&type=style&index=0&id=83f2a7f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f2a7f6",
  null
  
)

export default component.exports